import React, { useEffect, useMemo, useState } from "react";
import "./clubs.css";

function Clubs() {
    const [clubs, setClubs] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [error, setError] = useState("");
    const [query, setQuery] = useState("");

    // Modal crear/editar
    const [showForm, setShowForm] = useState(false);
    const [editingClub, setEditingClub] = useState(null);
    const [formNombre, setFormNombre] = useState("");
    const [formLocalidad, setFormLocalidad] = useState("");
    const [formEscudoFile, setFormEscudoFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState("");

    // Modal confirmar eliminación
    const [confirmDeleteClub, setConfirmDeleteClub] = useState(null);

    // Cargar lista
    const cargarClubs = () => {
        setCargando(true);
        fetch("/api/clubs")
            .then((res) => {
                if (!res.ok) throw new Error("Error al obtener clubs");
                return res.json();
            })
            .then((data) => setClubs(data))
            .catch((err) => setError(err.message))
            .finally(() => setCargando(false));
    };

    useEffect(() => {
        cargarClubs();
    }, []);

    // Filtro
    const filteredClubs = useMemo(() => {
        const q = query.trim().toLowerCase();
        if (!q) return clubs;
        return clubs.filter(
            (c) =>
                (c.nombre || "").toLowerCase().includes(q) ||
                (c.localidad || "").toLowerCase().includes(q)
        );
    }, [clubs, query]);

    // Manejo de archivo y preview
    const onChangeEscudo = (e) => {
        const file = e.target.files?.[0];
        setFormEscudoFile(file || null);
        if (file) {
            const url = URL.createObjectURL(file);
            setPreviewUrl(url);
        } else {
            setPreviewUrl("");
        }
    };

    const resetForm = () => {
        setFormNombre("");
        setFormLocalidad("");
        setFormEscudoFile(null);
        setPreviewUrl("");
        setEditingClub(null);
    };

    const abrirCrear = () => {
        resetForm();
        setShowForm(true);
    };

    const abrirEditar = (club) => {
        setEditingClub(club);
        setFormNombre(club.nombre || "");
        setFormLocalidad(club.localidad || "");

        const urlPreview =
            club.escudo && typeof club.escudo === "string" && /^https?:\/\//i.test(club.escudo)
                ? club.escudo
                : `/api/clubs/${club._id}/escudo?v=${club.updatedAt ? new Date(club.updatedAt).getTime() : Date.now()}`;
        setPreviewUrl(urlPreview);

        setShowForm(true);
    };

    if (cargando) return <div className="clubs-container">Cargando...</div>;
    if (error) return <div className="clubs-container error">{error}</div>;

    return (
        <div className="clubs-container">
            {/* Encabezado */}
            <div className="clubs-header">
                <div className="clubs-header-left">
                    <h1>Clubes</h1>
                </div>

                <div className="clubs-header-center">
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Buscar por nombre o localidad…"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        aria-label="Buscar clubs"
                    />
                </div>
            </div>

            <div className="club-grid">
                {filteredClubs.map((club) => (
                    <div className="club-container" key={club._id}>
                        <div className="escudo-cell">
                            {club.escudo ? (
                                <img
                                    src={
                                        typeof club.escudo === "string" && /^https?:\/\//i.test(club.escudo)
                                            ? club.escudo
                                            : `/api/clubs/${club._id}/escudo?v=${club.updatedAt ? new Date(club.updatedAt).getTime() : Date.now()}`
                                    }
                                    alt={`Escudo ${club.nombre}`}
                                    className="escudo"
                                    onError={(e) => (e.currentTarget.style.display = "none")}
                                />
                            ) : (
                                <div className="escudo placeholder">—</div>
                            )}
                        </div>
                        <h3>{club.nombre}</h3>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Clubs;
